import { render, staticRenderFns } from "./InformationBlock.vue?vue&type=template&id=b393b9d2&scoped=true"
import script from "./InformationBlock.vue?vue&type=script&lang=js"
export * from "./InformationBlock.vue?vue&type=script&lang=js"
import style0 from "./InformationBlock.vue?vue&type=style&index=0&id=b393b9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b393b9d2",
  null
  
)

export default component.exports